import styled from 'styled-components'
import { Media } from '../theme'

export const Main = styled.main`
  padding-top: 0px;
  ${Media.lessThan(Media.small)} {
    padding-top: unset;
  }
`
